export const arrayIntersect = (array1, array2) => {
  if (!array2?.length) {
    return array1;
  } else {
    return array1.filter(value => array2.includes(value));
  }
};
